import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FiMessageCircle } from 'react-icons/fi';
import { useTelegram } from '../../hooks/useTelegram';

const Page = styled.div`
  min-height: 100vh;
  background: #0a0a0f;
  padding: 16px;
  padding-bottom: 90px;
`;

const Title = styled.h1`
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 4px;
`;

const Sub = styled.p`
  color: rgba(255,255,255,0.4);
  font-size: 13px;
  margin-bottom: 28px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Card = styled.a`
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  display: block;
  aspect-ratio: 3/4;
  position: relative;
  transition: transform 0.2s;
  &:active { transform: scale(0.97); }
`;

const CardBg = styled.div`
  position: absolute;
  inset: 0;
  background: ${p => p.$bg || '#1a1a2e'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardIcon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.3));
`;

const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(0deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 40%, transparent 60%);
`;

const CardInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 14px;
`;

const CardName = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 6px;
`;

const CardAction = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #006FFF;
  font-weight: 600;
`;

const SERVICES = [
  { id: 'spotify', icon: '/icons/spotify.svg', name: 'Spotify Premium', desc: 'Подписка на музыку', bg: 'linear-gradient(135deg, #1DB954 0%, #158a3c 100%)' },
  { id: 'chatgpt', icon: '/icons/chatgpt.svg', name: 'ChatGPT Plus', desc: 'AI ассистент', bg: 'linear-gradient(135deg, #10a37f 0%, #0a7055 100%)' },
  { id: 'netflix', icon: '/icons/netflix.svg', name: 'Netflix', desc: 'Фильмы и сериалы', bg: 'linear-gradient(135deg, #E50914 0%, #831010 100%)' },
  { id: 'youtube', icon: '/icons/youtube.svg', name: 'YouTube Premium', desc: 'Без рекламы', bg: 'linear-gradient(135deg, #FF0000 0%, #990000 100%)' },
  { id: 'discord', icon: '/icons/discord.svg', name: 'Discord Nitro', desc: 'Улучшенный Discord', bg: 'linear-gradient(135deg, #5865F2 0%, #3c46a8 100%)' },
];

const ORDER_URL = 'https://t.me/openps_support';

const Services = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { tg, hapticFeedback } = useTelegram();

  useEffect(() => {
    const goBack = () => navigate('/');
    if (tg) {
      tg.setHeaderColor('#0a0a0f');
      tg.BackButton.show();
      tg.BackButton.onClick(goBack);
    }
    return () => { if (tg) { tg.BackButton.offClick(goBack); tg.BackButton.hide(); } };
  }, [tg, navigate]);

  return (
    <Page>
      <Title>🌍 Зарубежные сервисы</Title>
      <Sub>Подписки на популярные сервисы по выгодным ценам</Sub>

      <Grid>
        {SERVICES.map(svc => (
          <Card key={svc.id} href={ORDER_URL} target="_blank" onClick={() => hapticFeedback?.('light')}>
            <CardBg $bg={svc.bg}>
              <CardIcon src={svc.icon} alt={svc.name} />
            </CardBg>
            <CardOverlay />
            <CardInfo>
              <CardName>{svc.name}</CardName>
              <CardAction><FiMessageCircle size={11} /> Заказать</CardAction>
            </CardInfo>
          </Card>
        ))}
      </Grid>
    </Page>
  );
};

export default Services;
